import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
let accountFlg = 0;
//アカウント情報画面表示フラグ
export function useAccountInfoFlag() {
    const { pathname } = useLocation();

    const [isAccountInfo, setIsAccountInfo] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            const session = await fetchAuthSession();
            const accountInfoData = JSON.parse(session?.tokens?.idToken?.payload.accountInfoData?.toString() || "[]");
            //管理者かつ利用者アカウントのみ
            console.log(accountInfoData);
            if (accountInfoData.length === 2) setIsAccountInfo(true);
        })()
    }, []);

    if (pathname !== `/search`) return false;

    return isAccountInfo;
}

//検索条件入力画面表示フラグ
export function useSearchFlag() {
    const { pathname } = useLocation();
    const isFirstRender = useRef(true); // 初回かどうかのフラグ
    const [isSearch, setIsSearch] = useState<boolean>(false);
    // アカウント情報変更画面に遷移したことを検知する
    if (pathname === `/account`) accountFlg += 1;
    useEffect(() => {
        (async () => {
            if (isFirstRender.current) {
                isFirstRender.current = false;
                const session = await fetchAuthSession();
                const accountInfoData = JSON.parse(session?.tokens?.idToken?.payload.accountInfoData?.toString() || "[]");

                //管理者かつ利用者アカウントのみ
                setIsSearch(accountInfoData.length === 2);
                return;
            } else {
                if (pathname === `/account`) {
                    try {
                        const session = await fetchAuthSession();
                        const accountInfoData = JSON.parse(session?.tokens?.idToken?.payload.accountInfoData?.toString() || "[]");

                        //管理者かつ利用者アカウントのみ
                        setIsSearch(accountInfoData.length === 2);
                    } catch (e) {
                        // ログアウト時にセッション情報を取得しようとした場合を検知
                        if (e === 'NotAuthorizedException') {
                             console.log("未ログイン状態です（ゲストアクセス不可）");
                        }
                    }
                    
                }
            }

        })()
    }, [accountFlg]);

    if (pathname !== `/account`) return false;

    return isSearch;
}